// extracted by mini-css-extract-plugin
export default {"page":"MW-z","cartModal":"NW-z","checkout":"OW-z","placeholder":"PW-z","account":"QW-z"};